module.exports = __webpack_public_path__ + "static/antd-badge-basic-2749f4753de6ff34685b09e5490d47de.png";